<template>
  <div id="container">
      <Hearder />
      <router-view></router-view>
      <Footer />
  </div>
</template>

<script>
import Hearder from '@/components/Main/main_web/hearder'
import Footer from '@/components/Main/main_web/footer'
export default {
  name: 'Header',
  components: { Hearder, Footer },
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

</style>
